import { motion, useReducedMotion } from "framer-motion";
import { Button } from "../ui/Button";
import { Container } from "../ui/Container";
import { HeroCarousel } from "./HeroCarousel";
import { useSiteContent } from "../../lib/content";

export function Hero() {
  const { content } = useSiteContent();
  const reduce = useReducedMotion();
  const fade = (delay: number) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 18 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.5, delay },
        };

  return (
    <section
      id="inicio"
      className="relative flex min-h-[100svh] items-end overflow-hidden pb-20 pt-28 md:items-center md:pb-24 md:pt-32"
      aria-labelledby="hero-title"
    >
      <HeroCarousel />
      <Container className="relative z-10 max-w-3xl">
        <div className="rounded-2xl border border-white/35 bg-white/20 p-6 shadow-glow backdrop-blur-md light:border-black/10 light:bg-white/55 sm:p-8 md:p-10">
          <motion.p className="mb-3 font-heading text-sm text-accent-terminal" {...fade(0)}>
            {content.hero.eyebrow}
          </motion.p>
          <motion.h1
            id="hero-title"
            className="font-heading text-4xl font-bold tracking-tight text-primary sm:text-5xl"
            {...fade(0.08)}
          >
            {content.hero.title}
          </motion.h1>
          <motion.p className="mt-5 max-w-xl text-lg text-muted" {...fade(0.16)}>
            {content.hero.subtitle}
          </motion.p>
          <motion.div className="mt-8 flex flex-wrap gap-3" {...fade(0.24)}>
            <Button href="#contacto" size="lg">
              {content.hero.ctaPrimary}
            </Button>
            <Button href="#servicos" variant="secondary" size="lg">
              {content.hero.ctaSecondary}
            </Button>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}
